export const getLeadUUID = (state) => state.uuid;
export const getLeadExperience = (state) => state.experience;
